import { ACCOUNT_STATUS_CODE } from 'utilities/constants';
import {
  CARD_WATCH_REASON,
  FORM_FIELD,
  FRAUDULENT_CLOSED_REASONS,
  TIERED_WATCH_REASON,
} from './applyStatusConstants';

export const validateTWandCWReason =
  ({ agent, form, flags }) =>
  (_, value) => {
    const { isFdi, isFdr } = flags || {};

    const canApplyTW15orCW20 = agent?.isSuperUser || isFdi || isFdr;

    const statusCode = form.getFieldValue(FORM_FIELD.STATUS_CODE);
    const isTieredWatch = statusCode === ACCOUNT_STATUS_CODE.TIERED_WATCH;
    const isCardWatch = statusCode === ACCOUNT_STATUS_CODE.CARD_WATCH;

    const bypassReasons = [
      TIERED_WATCH_REASON.ADS_II_BYPASS,
      CARD_WATCH_REASON.FRAUD_ALERT_BYPASS,
    ];

    return new Promise((resolve, reject) => {
      if (!isTieredWatch && !isCardWatch) {
        return resolve();
      }
      if (bypassReasons.includes(value) && !canApplyTW15orCW20) {
        return reject(`Requires Super User, FDI or FDR privilege`);
      }
      if (!isCardWatch && !agent?.isSuperUser) {
        return reject(`Requires Super User privilege`);
      }
      resolve();
    });
  };

export const validateFraudulentClosedReason =
  ({ flags }) =>
  (_, value) => {
    const { isFraudOps, isSah, isS3FraudAgent, isEscalations } = flags || {};
    const canApplyFraudClosedStatus =
      isFraudOps || isSah || isS3FraudAgent || isEscalations;

    return new Promise((resolve, reject) => {
      if (
        FRAUDULENT_CLOSED_REASONS.includes(value) &&
        !canApplyFraudClosedStatus
      ) {
        return reject(`Requires Fraud Ops, SAH, or S3 privilege`);
      }
      resolve();
    });
  };
